<template>
    <Article>
        <template #header>
            <h2>Marauder Photo Albums</h2>
        </template>
        <template #content>
            <div>
                <p>
                    The photos linked from this page were taken by Marauders Bernie A. Jezercak,
                    Pete Ewing, and Quentin Waite when they were fighting in Burma. Bernie was a
                    member of 3rd Battalion, Orange Combat Team, I&amp;R Unit. Pete was a member of
                    MARS Task Force. Quentin was a member of the 2nd Battalion, Khaki Combat Team.
                    Each were issued a camera to take reconnaissance photos of enemy positions.
                    Luckily, they took photos of ordinary soldiers, officers (including Admiral
                    Louis Mountbatten), and Burmese villagers and their daily lives, medical field
                    hospital operations, and poignant moments at the graves of fallen soldiers.
                </p>
                <p>
                    We give a special thanks to Bernie, Pete, and Quentin for not only making these
                    photos available to the world, but also for taking them in the first place.
                </p>
                <p>
                    When you click on a link, a new window will open and you may scroll through the
                    photos.
                </p>
                <p>
                    <em>
                        All images appearing on this web page or linked to this page are the
                        exclusive property of Bernard A. Jezercak, Merrill &quot;Pete&quot; Ewing,
                        and Quentin Waite. The images may not be reproduced, copied, transmitted or
                        manipulated without written permission.
                    </em>
                </p>
                <p>&nbsp;</p>
                <p style="text-align:center">
                    <a href="https://photos.app.goo.gl/cwP3nbk76epd6E7j7">
                        Quentin Waite Photos
                    </a>
                </p>
                <p style="text-align:center">
                    <img
                        loading="lazy"
                        class="aligncenter wp-image-629 size-full"
                        style="border:1px solid #000"
                        src="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/Merrill-Pete-Ewing.jpg?alt=media"
                        alt="Merrill-Pete-Ewing"
                        width="130"
                        height="158"
                    />
                </p>
                <p style="text-align:center">
                    <a
                        href="https://photos.app.goo.gl/RHHpnB27B9kBBS8eA"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Pete Ewing Photos
                    </a>
                </p>
                <p style="text-align:center">
                    <img
                        loading="lazy"
                        class="aligncenter wp-image-630 size-full"
                        style="border:1px solid #000"
                        src="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/Bernie-Jezercak.jpg?alt=media"
                        alt="Bernie-Jezercak"
                        width="135"
                        height="158"
                    />
                </p>
                <p style="text-align:center">
                    <a
                        href="https://photos.app.goo.gl/DqibyEZcQYqkV8Mw6"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        BA Jezercak Photos
                    </a>
                </p>
            </div>
        </template>
    </Article>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Article from '@/components/Article/Article.vue';

export default defineComponent({
    name: 'MarauderPhotoAlbums',
    components: { Article }
});
</script>
